import { FarmTabButtons } from "./components/FarmTabButtons";
import { FarmApyButton } from "./components/FarmApyButton";
import Tags from "./components/Tags";
import FarmCard from "./components/FarmCard";
import StakedLP from "./components/StakedLP";
import DepositModal from "./components/DepositModal";
import WithdrawModal from "./components/WithdrawModal";
import FarmTable from "./components/FarmTable";

const Farm = {
  FarmTabButtons,
  FarmApyButton,
  Tags,
  FarmCard,
  StakedLP,
  DepositModal,
  WithdrawModal,
  FarmTable,
};

export { Farm };
